module.exports = __webpack_public_path__ + "static/media/banner.ff734764.jpg";